import React from 'react';
import './Product.css';
import { BsFillCartCheckFill } from "react-icons/bs";



const Product = (props) => {

    const {id,img,name,price,seller,ratings,shipping}= props.product;
    // const {id,img,name,price,seller,ratings}= product;
    // console.log(props);

    const {selectButton} = props;

    return (
        <div className="product">
            {/* <h3>This is product</h3> */}
             <img src={img} alt="" />
            <div className='product-info'>
            <p className='title text-black'>{name}</p>
                <p>Price: ${price}</p>
                <p><small>Seller: {seller}</small></p>
                <p><small>Shipping: ${shipping}</small></p>
                <p className="rating"><small>Ratings: {ratings} stars</small></p>
            </div>

            <div className="shoe-btn">
            <button onClick={()=>selectButton(id)} className='btn-cart'>
                <p className='btn-text'>Add to Cart</p>
               < BsFillCartCheckFill></BsFillCartCheckFill>
            </button> 
            </div>
            
        </div>
    );
};

export default Product;